export const sliceWalletAddress = (value: string) =>
  `${value.slice(0, 6)}...${value.slice(value.length - 5, value.length)}`;
